import {
  ILearning,
  getLearningApiClientFunctions,
} from "@kunduz/data-access-learning-api";
import { useQuery } from "@tanstack/react-query";

export function useQILecturesVideos(id: number): {
  lecturesVideos?: ILearning.LectureVideo | null;
  lecturesVideosLoading: boolean;
  lecturesVideosError: any;
} {
  const shouldFetch = !!id;
  const apiFunctions = getLearningApiClientFunctions();

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: ["QILearning Videos", id],
    queryFn: () => apiFunctions.getLearningConceptParent(id),
    enabled: shouldFetch,
  });

  return {
    lecturesVideos: data,
    lecturesVideosLoading: isLoading || isRefetching,
    lecturesVideosError: error,
  };
}
